module.exports = __webpack_public_path__ + "img/ico-chev-left--70L.0356a6e4.svg";